import React, { useEffect, useState, useRef } from "react";
import { Form } from "react-bootstrap";
import { AgGridReact } from '@ag-grid-community/react';
import { ModuleRegistry } from "@ag-grid-community/core";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { LicenseManager } from "@ag-grid-enterprise/core";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
import "../MainBox.css";
import { apiHelper } from "../../lib/ApiHelper";
import PRHLoader from "../../lib/PRHLoader";
// Register ag-Grid modules
ModuleRegistry.registerModules([ClientSideRowModelModule, RowGroupingModule, ExcelExportModule]);

// Set ag-Grid Enterprise license key
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058820}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Penguin_Random_House_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{InventoryHub}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{InventoryHub}_need_to_be_licensed___{InventoryHub}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[01]_MTc0MzcyMTIwMDAwMA==a87b1efc2ee2da35884b94c846d80314");

export default function Series(props) {
    const [seriesInfo, setSeriesInfo] = useState({ Series: "", SeriesName: "" });
    const [rowData, setRowData] = useState([]);
    const [otherWorkData, setOtherWorkData] = useState([]);
    const [selectedISBN, setSelectedISBN] = useState([]);
    const [selectedISBNAuth, setSelectedISBNAuth] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalISBN, setTotalISBN] = useState([]);
    const [heightSeriesGrid, setHeightSeriesGrid] = useState(100);
    const [heightAuthorGrid, setHeightAuthorGrid] = useState(100);
    const gridRef = useRef(null);
    const otherGridRef = useRef(null);

    // Generic selection handler that works with any grid API
    const handleSelectionChanged = (gridApi) => {
        if (!gridApi) return;

        // Detect which grid triggered the event
        const whichGrid = gridApi === gridRef.current?.api
            ? "SeriesGrid"
            : gridApi === otherGridRef.current?.api
                ? "OtherWorksGrid"
                : "UnknownGrid";

       

        const selectedRows = gridApi.getSelectedRows();
        const modifiedData = selectedRows.map(i => i.isbn);
       

        // Keep selections exclusive between grids
        if (whichGrid === "SeriesGrid") {
            setSelectedISBN(modifiedData);
          //  otherGridRef.current?.api?.deselectAll();
           
        } else if (whichGrid === "OtherWorksGrid") {
            setSelectedISBNAuth(modifiedData);
        //    gridRef.current?.api?.deselectAll();
            
        }

      
        const existingISBNs = (props?.isbnData?.listISBN || []).map(item => item.isbn);
        const modifiedSet = new Set(modifiedData);
        const filteredExisting = existingISBNs.filter(isbn => !modifiedSet.has(isbn));
        const totalList = [...modifiedData, ...filteredExisting];
        setTotalISBN(totalList);
    };

    const gridOptions = {
        defaultColDef: {
            resizable: true,
            sortable: true,
            filter: true,
        },
        animateRows: true,
        rowSelection: "multiple",
        accentedSort: true,
        suppressColumnMoveAnimation: false,
        suppressDragLeaveHidesColumns: true,
        suppressRowClickSelection: true,
        onSelectionChanged: (params) => handleSelectionChanged(params.api),
        // Note: onSelectionChanged removed here; each grid wires its own handler so we can
        // deselect the other grid when a selection happens.
    };

    const onGridReady = (params) => {
        //params.api.sizeColumnsToFit();
        params.api.setFilterModel({
            ss: {
                filterType: "text",
                operator: "AND",
                conditions: [
                    { type: "notContains", filter: "OS" },
                    { type: "notContains", filter: "RM" }
                ]
            }
        });
    };
/*
    const handleDeselectAll = () => {
        gridRef.current?.api?.deselectAll();
        otherGridRef.current?.api?.deselectAll();
        setSelectedISBN([]);
        setSelectedISBNAuth([]);
        setTotalISBN([]);
    };
*/
    function formatNumberWithCommas(number) {
        if (isNaN(number) || !number) {
            return '';
        }
        let str = number.toString();
        let parts = str.split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (parts[1] && parts[1].length === 1) {
            parts[1] += "0";
        }
        return parts.join(".");
    }

    const showFormatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return null;
    };

    // Export function accepts an optional grid ref
    const onExportClick = (gridRefParam = gridRef) => {
        const api = gridRefParam?.current?.api;
        if (!api) {
            alert("Grid API is not ready.");
            return;
        }

        if (!api.exportDataAsExcel) {
            alert("Excel export is not available. Please ensure the ag-Grid Enterprise Excel export module is imported and licensed.");
            return;
        }

        api.exportDataAsExcel({
            fileName: "series-data.xlsx",
            allColumns: true,
            processCellCallback: (params) => {
                const colId = params.column.getColId();
                if (colId === "isbn") {
                    return `'${params.value}`;
                }
                const dateFields = ["osd", "nextWIPDate", "lastRptDate"];
                if (dateFields.includes(colId) && params.value instanceof Date) {
                    const date = params.value;
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const day = String(date.getDate()).padStart(2, "0");
                    const year = date.getFullYear();
                    return `${month}/${day}/${year}`;
                }
                return params.value;
            }
        });
    };

    useEffect(() => {
        const fetchSeries = async () => {
            setSeriesInfo({ Series: "", SeriesName: "" });
            setRowData([]);
            setLoading(true);
            const isbnId = props?.ISBNId;
            if (props?.metaData && isbnId && isbnId !== "") {
                const resulttemp = await apiHelper.inventoryPostCall("getseries", { value: isbnId });
                if (resulttemp) {
                    const { seriesValue, otherWork } = resulttemp;
                    if (seriesValue && seriesValue.seriesInfo && seriesValue.seriesData) {
                        setSeriesInfo({
                            Series: seriesValue.seriesInfo.series ?? "",
                            SeriesName: seriesValue.seriesInfo.seriesName ?? ""
                        });
                        setRowData(seriesValue.seriesData);
                        setHeightSeriesGrid(Math.min(27 * (seriesValue.seriesData.length + 2), 433));
                    } else {
                        setSeriesInfo({ Series: "", SeriesName: "" });
                        setRowData([]);
                    }
                    // --- Handle OtherWork (new dataset) ---
                    if (otherWork?.seriesData && otherWork.seriesData.length > 0) {
                        setOtherWorkData(otherWork.seriesData);
                        setHeightAuthorGrid(Math.min(27 * (otherWork.seriesData.length + 2), 433));
                    } else {
                        setOtherWorkData([]);
                    }
                } else {
                    setSeriesInfo({ Series: "", SeriesName: "" });
                    setRowData([]);
                    setOtherWorkData([]);
                }
            }
            setLoading(false);
        };
        fetchSeries();
        setSelectedISBN([]);
        setSelectedISBNAuth([]);
        setTotalISBN([]);
    }, [props.metaData]);

    // Use a stable handler to avoid multiple calls
    const handleClicked = (isbn) => (event) => {
        event.stopPropagation();
        if (isbn) {
            window.open(`/overview?isbns=${isbn}`, '_blank');
        }
    };

    const selectISBNClick = async () => {
        const prepend = false;
        const formOverview = true; // extra check for duplicates
        const updateSetTitle = true;
        if (!totalISBN || totalISBN.length === 0) {
            gridRef?.current?.api?.deselectAll();
            otherGridRef?.current?.api?.deselectAll();
            return;
        }
        await apiHelper.ISBNCheck(totalISBN, props.upn, props.setIsbnData, props.isbnData, prepend, formOverview, updateSetTitle);
    };

    const columnDefs = [
        { headerName: '', width: 40, checkboxSelection: true, headerCheckboxSelection: true, multipleSelection: true, suppressMenu: true, headerClass: "HeaderClassSource1", cellClass: "checkboxcell" },
        {
            headerName: "ISBN", field: "isbn", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left cursor-pointer link-isbn", width: 100, cellRenderer: (params) => {
                return <span onClick={handleClicked(params.value)}>{params.value}</span>;
            }, filter: "agSetColumnFilter"
        },
        { headerName: "Title", field: "title", resizable: true, sortable: true, filter: "agSetColumnFilter", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 200 },
        {
            headerName: "OSD", field: "osd", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right",
            filter: "agDateColumnFilter",
            valueGetter: (params) => {
                if (!params.data.osd || params.data.osd === "0001-01-01T00:00:00") return null;
                return new Date(params.data.osd);
            },
            valueFormatter: (params) => {
                return showFormatDate(params.value);
            },
            filterParams: {
                comparator: (filterLocalDateAtMidnight, cellValue) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue);
                    return cellDate.setHours(0, 0, 0, 0) - filterLocalDateAtMidnight.getTime();
                }, filterPlaceholder: (params) => {
                    switch (params.filterOptionKey) {
                        case "greaterThanOrEqual":
                            return "Enter start date...";
                        case "lessThanOrEqual":
                            return "Enter end date...";
                        case "inRange":
                            return "Select range...";
                        default:
                            return params.placeholder;
                    }
                }
            },
            sort: 'desc',
            width: 80,
        },
        {
            headerName: "Fmt", field: "fmt", resizable: true, sortable: true, filter: "agTextColumnFilter", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 100,
        },
        {
            headerName: "SS", field: "ss", resizable: true, sortable: true, filter: "agTextColumnFilter", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width:100,
        },
        { headerName: "Active Batch", field: "activeBatch", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 120, filter: "agSetColumnFilter" },
        {
            headerName: "Gross Inv", field: "grossInv", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, cellClass: "CellClassSource cell-text-right", width: 100, filter: "agNumberColumnFilter"
        },
        {
            headerName: "Net Bulk Inv", field: "netBulkInv", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, cellClass: "CellClassSource cell-text-right", width: 120, filter: "agNumberColumnFilter"
        },
        {
            headerName: "Total WIP", field: "totalWIP", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, cellClass: "CellClassSource cell-text-right", width: 100, filter: "agNumberColumnFilter"
        },
        {
            headerName: "Next WIP Dte", field: "nextWIPDate", resizable: true, sortable: true, headerClass: "HeaderClassSource",  cellClass: "CellClassSource cell-text-right", 
            filter: "agDateColumnFilter",
            valueGetter: (params) => {
                if (!params.data.nextWIPDate || params.data.nextWIPDate === "0001-01-01T00:00:00") return null;
                return new Date(params.data.nextWIPDate);
            },
            valueFormatter: (params) => {
                return showFormatDate(params.value);
            },
            filterParams: {
                comparator: (filterLocalDateAtMidnight, cellValue) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue);
                    return cellDate.setHours(0, 0, 0, 0) - filterLocalDateAtMidnight.getTime();
                }, filterPlaceholder: (params) => {
                    switch (params.filterOptionKey) {
                        case "greaterThanOrEqual":
                            return "Enter start date...";
                        case "lessThanOrEqual":
                            return "Enter end date...";
                        case "inRange":
                            return "Select range...";
                        default:
                            return params.placeholder;
                    }
                }
            },
            width: 130
        },
        {
            headerName: "Page Count", field: "pageCount", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, cellClass: "CellClassSource cell-text-right", width: 100, filter: "agNumberColumnFilter"
        },
        {
            headerName: "Trim Size", field: "trimSize", resizable: true, sortable: true, filter: "agTextColumnFilter", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 100,
        }
    ];

    return (
        <div className="accordion-content container-fluid specform">
            {loading && (
                <div style={{ marginLeft: "10px", marginBottom: "10px" }}>
                    <PRHLoader />
                </div>
            )}
            <Form noValidate="noValidate" style={{ marginLeft: "10px", marginTop:"10px" }}>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <Form.Group controlId="seriesId">
                                    <Form.Label>Series</Form.Label>
                                    <input
                                        className="custom-input left-p-input"
                                        type="text"
                                        value={seriesInfo.Series}
                                        disabled
                                        placeholder="Series"
                                        style={{ width: 120 }}
                                    />
                                </Form.Group>
                            </td>
                            <td className="pl-4">
                                <Form.Group controlId="seriesNameId">
                                    <Form.Label>Series Name</Form.Label>
                                    <input
                                        className="custom-input left-p-input"
                                        type="text"
                                        value={seriesInfo.SeriesName}
                                        disabled
                                        placeholder="Series Name"
                                        style={{ width: 220 }}
                                    />
                                </Form.Group>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Form>
            
                <div style={{ paddingLeft: "10px", marginTop: "25px" }}>
                {rowData?.length > 0 && <>
                    <p className="ml-0 mb-0 fw-2" style={{ fontSize: "16px" }}>Series</p>
                    <div className="">
                        <button className="ISBNSubmit exprt-match ml-0" onClick={(e) => {
                            onExportClick();
                        }}>   <i className="fa fa-lg fa-download icon"></i>Export to Excel</button>
                        <button className="ISBNSubmit  exprt-match" disabled={selectedISBN.length < 1} onClick={selectISBNClick}> <i className="fa fa-lg fa-plus icon"></i>Add to Title List</button>
                    </div>
                    <div className="ag-theme-balham" style={{ marginBottom: "20px", height: heightSeriesGrid, overflow: "auto", width: "1390px" }}>
                        <AgGridReact
                            rowData={rowData}
                            ref={gridRef}
                            onGridReady={onGridReady}
                            columnDefs={columnDefs}
                            gridOptions={gridOptions}
                            alwaysShowHorizontalScroll={true}
                            suppressHorizontalScroll={false}
                        />
                    </div>
                </>}
                {otherWorkData?.length > 0 && <>
                    <div className="">
                        <p className="ml-0 mb-0 fw-2" style={{ fontSize: "16px" }}>Other Works by Author</p>
                        <div className="">
                            <button className="ISBNSubmit exprt-match ml-0" onClick={(e) => {
                                onExportClick(otherGridRef);
                            }}>   <i className="fa fa-lg fa-download icon"></i>Export to Excel</button>
                            <button className="ISBNSubmit  exprt-match" disabled={selectedISBNAuth.length < 1} onClick={selectISBNClick}> <i className="fa fa-lg fa-plus icon"></i>Add to Title List</button>
                        </div>
                    </div>
                    <div className="ag-theme-balham" style={{ marginBottom: "20px", overflow: "auto", width: "1390px", height: heightAuthorGrid }}>
                        <AgGridReact
                            rowData={otherWorkData}
                            columnDefs={columnDefs}
                            gridOptions={gridOptions}
                            ref={otherGridRef}
                            alwaysShowHorizontalScroll={true}
                            suppressHorizontalScroll={false}
                        />
                    </div></>}
                </div>
        </div>
    );
}
